import * as React from 'react';
import { cn } from '../lib/utils.js';

const Skeleton = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => (
    <div
      ref={ref}
      aria-hidden="true"
      data-slot="skeleton"
      className={cn(
        'relative overflow-hidden rounded bg-muted animate-skeleton-in motion-reduce:animate-none',
        'after:absolute after:inset-0 after:-translate-x-full after:animate-skeleton-shimmer after:bg-gradient-to-r after:from-transparent after:via-background/60 after:to-transparent motion-reduce:after:animate-none',
        className,
      )}
      {...props}
    />
  ),
);
Skeleton.displayName = 'Skeleton';

export { Skeleton };
